import { useEffect } from 'react'
import { useUIStore } from '@/stores/uiStore'

/**
 * Applies the persisted theme on mount and listens for system preference changes.
 * Must be called once at the app layout level (e.g. MainLayout).
 */
export function useThemeEffect() {
  const theme = useUIStore((state) => state.theme)

  useEffect(() => {
    const root = document.documentElement

    if (theme === 'dark') {
      root.classList.add('dark')
      return
    }

    if (theme === 'light') {
      root.classList.remove('dark')
      return
    }

    // System: follow prefers-color-scheme
    const mq = window.matchMedia('(prefers-color-scheme: dark)')
    root.classList.toggle('dark', mq.matches)

    const handler = (e: MediaQueryListEvent) => {
      root.classList.toggle('dark', e.matches)
    }
    mq.addEventListener('change', handler)
    return () => mq.removeEventListener('change', handler)
  }, [theme])
}
